/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsDressingsInactivateAliases {
  FIELD_JUSTFY = 'field-justfy',
  FORM_WOUNDS_DRESSINGS_INACTIVATE = 'form-wounds-dressings-inactivate',
  LAYOUT_WOUNDS_DRESSINGS_INACTIVATE = 'layout-wounds-dressings-inactivate',
  PANEL_WOUNDS_DRESSINGS_INACTIVATE = 'panel-wounds-dressings-inactivate',
  TEXT_AREA_JUSTIFY = 'text-area-justify',
}
export { WoundsDressingsInactivateAliases };
